module.exports = __webpack_public_path__ + "static/media/desbravador_o.a6c2a489.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/desbravador_o.png
// module id = 1179
// module chunks = 0